// Shared formatting + status-chip logic for the float-requests feature.

// `awaiting` is the API's preferred source of truth — it collapses the
// pending/approved/processing lifecycle into "who is holding this right
// now", so prefer it over deriving a chip from `status` directly.
export const AWAITING_META = {
  hop_review: { label: "Awaiting approval", bg: "#fef3c7", color: "#d97706" },
  admin_processing: {
    label: "Approved — awaiting payout",
    bg: "#dbeafe",
    color: "#2563eb",
  },
  wallet_transfer: {
    label: "Processing payout",
    bg: "#dbeafe",
    color: "#2563eb",
    spinner: true,
  },
};

// `awaiting` is null once a request is finished (funded/rejected) — fall
// back to `status` there. `failed` has no `awaiting` value of its own but
// isn't a dead end (it re-enters the admin's payout queue), so it gets its
// own entry rather than falling through to a generic label.
const FINISHED_META = {
  funded: { label: "Funded", bg: "#dcfce7", color: "#16a34a" },
  rejected: { label: "Rejected", bg: "#fee2e2", color: "#dc2626" },
  failed: { label: "Failed — retrying", bg: "#fee2e2", color: "#dc2626" },
};

export const getRequestChip = (request) => {
  if (!request) return null;
  if (request.awaiting && AWAITING_META[request.awaiting]) {
    return AWAITING_META[request.awaiting];
  }
  return (
    FINISHED_META[request.status] || {
      label: request.status,
      bg: "#f3f4f6",
      color: "#6b7280",
    }
  );
};

// A center can only have one request in flight — pending/approved/processing
// — at a time; the API 400s on a second submission while one of these is open.
export const isOpenStatus = (status) =>
  ["pending", "approved", "processing"].includes(status);

export const formatAmount = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return `₦${num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
